import classes from "./card-view-correlated-service.module.scss";
import Label from "@/components-library/widgets/label";
import Flex from "@/components-library/layout/flex";
import Button from "@/components-library/widgets/button";
import { PLACEHOLDER } from "@/common/announcement-helper";
function CardViewCorrelatedService({
  title,
  description,
  fromAdmin,
  onServiceAdd,
  isInOffer,
  isSelectable,
  image,
}) {
  return (
    <Flex
      align="center"
      direction="column"
      justify="space-between"
      className={classes.container}
    >
      <Flex align="center" direction="column" justify="flex-start">
        <img
          src={image ? image : PLACEHOLDER}
          alt="Logo"
          onError={({ currentTarget }) => {
            currentTarget.onerror = null; // prevents looping
            currentTarget.src = PLACEHOLDER;
          }}
          className={classes.image}
        />

        <Flex
          align="flex-start"
          direction="column"
          justify="center"
          className={classes.content}
        >
          <Label
            weight="bold"
            tag="h5"
            color="secondary"
            align="start"
            className={classes.title}
          >
            {title}
          </Label>

          <Label
            align="start"
            size="md"
            color="secondary"
            className={classes.description}
          >
            {description}
          </Label>
        </Flex>
      </Flex>
      <Flex
        align="flex-start"
        direction="column"
        justify="center"
        className={classes.bottom}
      >
        {!isSelectable && !fromAdmin && (
          <Label
            align="start"
            size="md"
            color="secondary"
            weight="bold"
            className={classes.errorMessage}
          >
            Non puoi aggiungere questo servizio alla tua soluzione
            personalizzata perché non è incluso in tutti i bandi selezionati
          </Label>
        )}
        {isSelectable && !isInOffer && !fromAdmin && (
          <Button
            onClick={onServiceAdd}
            size="sm"
            color="primary"
            isEnabled={!fromAdmin}
            className={classes.button}
          >
            AGGIUNGI ALL'OFFERTA
          </Button>
        )}
        {isSelectable && isInOffer && !fromAdmin && (
          <Flex
            align="center"
            direction="row"
            justify="space-between"
            style={{ width: "100%" }}
          >
            <Flex align="center" direction="row" justify="flex-start">
              <img src={"/images/icons/checkmark.svg"} alt="Check" />
              <Label weight="bold" color="primary" align="start" size="sm">
                SERVIZIO AGGIUNTO
              </Label>
            </Flex>
            <img
              src={"/images/icons/icon-close.svg"}
              alt="Check"
              onClick={onServiceAdd}
            />
          </Flex>
        )}
      </Flex>
    </Flex>
  );
}

export default CardViewCorrelatedService;
